import React, { useEffect } from "react";

const OAuthCallback: React.FC = () => {
  // const [searchParams] = useSearchParams();
  // const code = searchParams.get("code") as string;
  // const { socialLogin } = useParams<{ socialLogin: string }>();
  // const mutation = useMutation(
  //   (data: { provider: string; code: string }) =>
  //     AuthService.outboundLogin(data.provider, data.code),
  //   {
  //     onSuccess: (data) => {
  //       localStorage.setItem("token", data.token);
  //       console.log(data);
  //       window.close();
  //     },
  //     onError: (error: any) => {
  //       alert("fail: " + error.message);
  //       window.close();
  //     },
  //     retry: false,
  //   },
  // );
  // useEffect(() => {
  //   if (code) {
  //     if (socialLogin) {
  //       mutation.mutate({ provider: socialLogin, code });
  //     } else {
  //       console.error("Social login provider is undefined");
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [code, socialLogin]);

  useEffect(() => {
    if (localStorage.getItem("DEBUG_MODE")) {
      return;
    }
    window.close();
  }, []);
  return <div>Authenticating...</div>;
};

export default OAuthCallback;
